export default function showError(response, vm) {
  // ユーザーtoken無効の場合
  if(response.code === 'auth/user-token-expired'){
    vm.$store.commit("app/showErrorDialog", true, { root: true });
    vm.$store.commit("app/showErrorMessage", "ユーザートークン無効、再ログインしてください", { root: true });
    vm.$store.commit("app/showErrorCode", "auth/user-token-expired", { root: true });
  }else if (response.status === 200) {
    // エラーダイアログ表示
    Object.keys(vm.$p.message.error).filter(k => {
      let errorCode = k.replace(/_/g, '/');
      if (response.data.errorCode === errorCode) {
        vm.$store.commit("app/showErrorDialog", true, { root: true });
        vm.$store.commit("app/showErrorMessage", vm.$p.message.error[k], { root: true });
        vm.$store.commit("app/showErrorCode", errorCode, { root: true });
      }
    })
  } else {
    //ステータスコード200以外通信エラー
    vm.$store.commit("app/showErrorDialog", true, { root: true });
    vm.$store.commit("app/showErrorMessage", "通信エラー", { root: true });
    vm.$store.commit("app/showErrorCode", response.message, { root: true });
  }
}
